import { scale } from '@utils/normalize';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  arrowIconStyles: { marginLeft: scale(4), paddingRight: scale(10.5) },
  referralInputContainer: { alignItems: 'center', flexDirection: 'row', marginTop: scale(4) },
  referralParent: { marginHorizontal: scale(16), marginTop: scale(16) },
});
export default styles;
